"use client"
import { MobileSide } from './MobileSide';
import { useBrowser } from '@/hooks/useBrowser';

interface MobileDetectProps extends React.PropsWithChildren {
  MobileSideComponent?: React.ComponentType<any>
}
export const MobileDetect = ({
  children,
  MobileSideComponent = MobileSide,
}: MobileDetectProps) => {
  const browser = useBrowser();

  if (!browser) {
    return children;
  }
  if (browser.parsePlatform().type === 'mobile') {
    return <MobileSideComponent />
  }

  return children;
};